// import uchastniki from "./uchastniki"
export default {
    title: 'Программа мероприятия',
    list: [
        {
            time: '10:00 - 10:30',
            title: 'Регистрация участников',
        },
        {
            time: '10:30 - 10:40',
            title: 'Приветствие',
        },
        {
            time: '10:40 - 11:20',
            title: 'Михаил Шакин',
            list: [
                {
                    title: 'Сайт как основа привлечения первичных пациентов',
                    list: [
                        'Мировые тренды ИИ и их применение для врачей и медицинских сайтов.',
                        'Доверие пациентов через экспертность и прозрачность врача и клиники.',
                        'Многостраничный сайт врача, клиники vs лендинг: стратегии для разных задач.',
                        'Контент-маркетинг и SEO: как врачу стать находкой для пациента.',
                        'Удобство сайта как конкурентное преимущество.',
                        
                    ]
                }
            ],
        },
        {
            time: '11:20 - 12:00',
            title: 'Виктор Чистилин',
            // list: uchastniki.list[2].agenda 
            list: [
                {
                    title: 'Приручаем агрегаторы: пошаговый план для клиник и врачей по увеличению пациентов',
                    list: [
                        'Обзор рынка медицинских агрегаторов — какие площадки работают лучше всего и что учитывать при выборе.',
                        'Как прокачать карточки врачей — практические советы по улучшению анкет, отзывов и рейтинга.',
                        'Как врачу сделать карточку, которая привлекает пациентов — какие детали важно указать, как правильно оформить описание, какие фото и документы повышают доверие и увеличивают запись.',
                        'Что смотреть у конкурентов — как анализировать чужие страницы и использовать эти данные для роста.',
                        'Как вам может помочь менеджер площадки — скрытые возможности агрегаторов, о которых знают не все.',
                        'Запись «в режиме реального времени» как конкурентное преимущество — почему это важно и как внедрить.',
                        '45 ₽ за лид и другие неочевидные «фишки» работы с агрегаторами — кейсы, лайфхаки и нестандартные подходы.',
                        'Когда врач и клиника зря тратят деньги на агрегаторы — в каких случаях реклама не принесет пациентов и что делать вместо этого.',
                    ]
                }
            ]
            // list: [
            //     {
            //         title: '',
            //         list: [
            //             'Обзор рынка медицинских агрегаторов Продокторов, Напоправку, Zoon',
            //             'Как прокачать карточки врачей',
            //             'Что смотреть у конкурентов',
            //             'Как вам может помочь менеджер площадки',
            //             'Запись «в режиме реального времени» как конкурентное преимущество',
            //             '45 ₽ за лид и другие неочевидные «фишки» работы с агрегаторами',
            //         ],
            //     }
            // ]
        },
        {
            time: '12:00 - 12:40',
            title: 'Кофе-брейк',
        },
        {
            time: '12:40 - 13:20',
            title: 'Руслан Антропов',
            list: [
                {
                    title: 'Может ли блог на сайте приносить первичных пациентов, как это работает?',
                    list: [
                        'Зачем нужен блог для медицинской клиники',
                        'Как блог помогает приводить первичных пациентов',
                        'Существуют требования, к медицинскому сайту, которые необходимо соблюдать',
                        'Сколько времени нужно, что бы блог начал приносить трафик и пациентов, и какие есть гарантии?',
                        'Как вести блог? Какие работы надо выполнять? Кто необходим для реализации?',
                    ],
                }
            ]
        },
        {
            time: '13:20 - 14:00',
            title: 'Глеб Андриишин',
            list: [
                {
                    title: 'Как получать пациентов при помощи ГЕО сервисов',
                    list: [
                        'Изменения и нововведения 2025: новые правила Яндекса',
                        'Преимущества работы с Яндекс Бизнесом',
                        'Введение в Яндекс Бизнес: возможности платформы для бизнеса и актуальность использования Яндекс сервисов в 2024 году',
                        'Стратегия работ над репутацией: на что влияет, как эффективно отвечать на отзывы, как обрабатывать негатив',
                        'Заполнение карточки на Яндекс Бизнесе: основные элементы, роль фотографий, историй и описаний',
                    ],
                }
            ]
        },
        {
            time: '14:00 - 14:40',
            title: 'Антон Гладченко',
            list: [
                {
                    count: 1,
                    title: 'Продвижение клиники vs. Продвижение врача',
                    list: [
                        'Развитие бренда врача в Telegram',
                        'Какой контент создавать врачу в Telegram',
                        'Как использовать Telegram Ads для продвижения блога врача',
                        'Привлечение первичных пациентов через Telegram без рекламы',
                        'Эдьютейнмент – ключ к привлечению Ваших пациентов',
                        'Свой канал или бот',
                        '7 грехов, которые мешают врачам привлекать пациентов через Telegram',
                        'Чем раньше начнете, тем лучше. Часики тикают, реклама дорожает',
                        'Зачем Telegram клинике сегодня',
                        'Прямая реклама или развитие бренда',
                        'Telegram Ads: плюсы и минусы для клиник',
                    ]
                },
                {
                    count: 1,
                    title: 'Привлечение первичных пациентов через Яндекс Директ',
                    list: [
                        'Форматы рекламы в Яндекс, которые подходят клиникам',
                        'Сквозная аналитика - ключ к успеху рекламы клиники',
                        'Борьба с фродом и оптимизация на целевые заявки от пациентов',
                        'Автостратегии в мед. рекламе',
                        'Важность комплексного подхода, медийности и как это влияет на лиды с Яндекс Директ',
                    ]
                },
            ]
        },
        {
            time: '14:40 - 15:30',
            title: 'Обед для участников конференции (Шведский стол)',
        },
        {
            time: '15:30 - 16:10',
            title: 'Павел Пресняков',
            list: [
                {
                    title: 'Личный бренд для врачей в ВК',
                    list: [
                        'Сообщество ВКонтакте - почему без него никуда ',
                        'Воронки продаж для клиник ',
                        'Какой должен быть контент и как его автоматизировать ',
                        'Рекламные возможности ВКонтакте ',
                        'Сколько стоит один пациент',
                        'ВК видео и ВК клипы - как новый тренд в привлечении пациентов',
                        'Личный бренд в ВК для врача',
                        'Какой контент создавать в ВК врачу',
                        'Как получать подписчиков без бюджета врачу в ВК',
                    ],
                }
            ]
        },
        {
            time: '16:10 - 16:50',
            title: 'Елена Бирюкова',
            list: [
                {
                    // title: 'Личный бренд врача',
                    title: 'Системный маркетинг: как увеличить прибыль за счет соцсетей',
                    list: [
                        'Основные тенденции продвижения в 2025 году',
                        'Почему нельзя складывать яйца в одну корзину',
                        'Альтернативные площадки: преимущества',
                        'Эмоциональный брендинг: что это и зачем нужен?',
                        'Чат-боты и AI- помощники',
                        'Все о маркировке рекламы: как не попасть на штрафы',
                        // 'Когда и кому нужен личный бренд: сложности, о которых не говорят.',
                        // 'Какие возможности дает раскрученный личный бренд: мифы и реальность.',
                        // 'Кризис, первичные пациенты и личный бренд: в чем связь.',
                        // 'Коллаборация брендированного врача и клиники: как вместе заработать больше.',
                        // 'Важные шаги для развития: с чего начать и как продолжить, чтобы получить результаты.',
                        // 'Особенности развития личного бренда в разных соцсетях',
                        
                    ],
                },
                // {
                //     title: 'Автоматизация процессов и использование ИИ для развития соцсетей и привлечения пациентов',
                //     list: [
                //         'Контент: от постов до видео.',
                //         'Чат-боты: как работать с аудиторией, чтобы она покупала ваши услуги.',
                //         'AI-ассистент: как продавать свои услуги без личного участия.',
                //     ]
                // },
            ]
        },
        {
            time: '16:50 - 17:30',
            title: 'Малика Фёдорова',
            list: [
                {
                    title: 'Первичная консультация-как ключ к записи на несколько месяцев вперед.',
                    list: [
                        'Причинно-следственная связь вашей стратегии, жизненных ценностей и вашей записи.',
                        'Математика правильной плановой косметологии.',
                        'Как ответить на вопрос- зачем мне соц.сети.',
                        'Роль социальных сетях в формировании имиджа и статуса врача.',
                        'Почему пациенты идут не к вам?',
                        'Успешный косметолог — это не просто имя, это поток пациентов, доверие и репутация.',
                        'Первичная консультация главная встреча с пациентом, на которой он ответит да или нет',
                        '3 главных составляющих успеха',

                        // 'Как сформировать запись на несколько месяцев вперед',
                        // 'Роль социальных сетей в формировании имиджа и статуса врача',
                        // 'Почему пациенты идут не к вам? Какой контент привлечет к вам пациентов',
                        // 'Узнайте, как выделиться среди сотен косметологов',
                        // 'Успешный косметолог — это не просто имя: это поток пациентов, доверие и репутация',
                        // 'Первичная консультация: главная встреча с пациентом, на которой он ответит «да» или «нет»',
                        // 'Чего никогда нельзя делать в общении с пациентом',
                        // 'Причинно-следственная связь вашей стратегии, жизненных ценностей и вашей записи',
                        // 'Математика правильной плановой косметологии',
                    ],
                }
            ]
        },
        {
            time: '17:40 - 19:10',
            title: 'Нетворкинг',
        },
    ]
}